import { environment } from '@environments/environment';
import { FfNgxLoadingScreenConfig } from '@fagforbundet/ngx-components';

export const loadingScreenConfig: FfNgxLoadingScreenConfig = {
  debug: environment.loadingScreen.debug,
  showLoadingScreenOnNavigation: true,
};
